module.exports = __webpack_public_path__ + "img/card_walking_distance.ada87eb5.png";